// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarTipoVolatilidade,
  getTipoVolatilidadeSelecionada,
  getTipoVolatilidade,
} from "../../../../state";

export default function SelecaoTipoVolatilidade() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"Comum.Tipo"}
        itensSelector={getTipoVolatilidade}
        selectorItemSelecionado={getTipoVolatilidadeSelecionada}
        onItemChange={selecionarTipoVolatilidade}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
        radioName="tipoVolatilidade"
      />
    </div>
  );
}
